module.exports = __webpack_public_path__ + "static/media/event.895e1f14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage_new/images/event/event.jpg
// module id = 2690
// module chunks = 0